<div class="flex flex-col gap-8">
  <!-- Functional Location CSV -->
  <p-card>
    <ng-template pTemplate="header">
      <div class="px-4 pt-4">
        <h2 class="text-lg font-semibold">
          Localisation fonctionnelle par règle
        </h2>
        <p class="text-sm text-gray-500 mt-1">
          Importez un fichier CSV pour associer les localisations fonctionnelles
          SAP aux règles. Format attendu : <code>rule_uid,sap_id</code> (avec
          en-tête).
        </p>
      </div>
    </ng-template>

    <div class="flex flex-col gap-4">
      <div class="flex items-center gap-3">
        <p-fileUpload
          mode="basic"
          accept=".csv"
          chooseLabel="Choisir un fichier CSV"
          [auto]="false"
          [customUpload]="true"
          (onSelect)="onFunctionalLocationFileSelected($event)"
          styleClass="p-button-outlined"
        ></p-fileUpload>

        <span *ngIf="functionalLocationFile" class="text-sm text-gray-600">
          {{ functionalLocationFile.name }}
        </span>

        <p-button
          label="Importer"
          icon="pi pi-upload"
          [disabled]="!functionalLocationFile || isFunctionalLocationImporting"
          [loading]="isFunctionalLocationImporting"
          (onClick)="onImportFunctionalLocation()"
        ></p-button>
      </div>

      <p-message
        *ngIf="functionalLocationError"
        severity="error"
        [text]="functionalLocationError"
      ></p-message>

      <div *ngIf="functionalLocationResult">
        <p-message
          severity="success"
          [text]="functionalLocationResult.summary"
        ></p-message>

        <div
          *ngIf="
            functionalLocationResult.skippedFunctionalLocationNotFound.length >
            0
          "
          class="mt-3"
        >
          <h3 class="text-sm font-semibold mb-2">
            Localisations fonctionnelles introuvables :
          </h3>
          <p-table
            [value]="functionalLocationResult.skippedFunctionalLocationNotFound"
            [tableStyle]="{ 'min-width': '20rem' }"
          >
            <ng-template pTemplate="header">
              <tr>
                <th>Rule UID</th>
                <th>SAP ID</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td>{{ row.ruleUid }}</td>
                <td>{{ row.sapId }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </p-card>

  <!-- Labels CSV -->
  <p-card>
    <ng-template pTemplate="header">
      <div class="px-4 pt-4">
        <h2 class="text-lg font-semibold">Étiquettes de règles</h2>
        <p class="text-sm text-gray-500 mt-1">
          Importez un fichier CSV pour associer des étiquettes aux règles.
          Format attendu : <code>label,,rule_fk,work_center_sap_id</code> (avec
          en-tête).
        </p>
      </div>
    </ng-template>

    <div class="flex flex-col gap-4">
      <div class="flex items-center gap-3">
        <p-fileUpload
          mode="basic"
          accept=".csv"
          chooseLabel="Choisir un fichier CSV"
          [auto]="false"
          [customUpload]="true"
          (onSelect)="onLabelsFileSelected($event)"
          styleClass="p-button-outlined"
        ></p-fileUpload>

        <span *ngIf="labelsFile" class="text-sm text-gray-600">
          {{ labelsFile.name }}
        </span>

        <p-button
          label="Importer"
          icon="pi pi-upload"
          [disabled]="!labelsFile || isLabelsImporting"
          [loading]="isLabelsImporting"
          (onClick)="onImportLabels()"
        ></p-button>
      </div>

      <p-message
        *ngIf="labelsError"
        severity="error"
        [text]="labelsError"
      ></p-message>

      <div *ngIf="labelsResult">
        <p-message severity="success" [text]="labelsResult.summary"></p-message>

        <div *ngIf="labelsResult.errors.length > 0" class="mt-3">
          <h3 class="text-sm font-semibold mb-2">Erreurs d'importation :</h3>
          <p-table
            [value]="labelsResult.errors"
            [tableStyle]="{ 'min-width': '30rem' }"
          >
            <ng-template pTemplate="header">
              <tr>
                <th>Ligne</th>
                <th>Raison</th>
                <th>Données</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td>{{ row.rowNumber }}</td>
                <td>{{ row.reason }}</td>
                <td>{{ row.rawData }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </p-card>
</div>
